export default __webpack_public_path__ + "static/Battery-Point-01c517c64c9da87b9e12691d3cf00825.jpg";